"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.omit"));

var _Addon = _interopRequireDefault(require("./Addon"));

require("../styles/_applied-addons.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function Applied(_ref) {
  var currentVersion = _ref.currentVersion,
      getFormattedAddon = _ref.getFormattedAddon,
      getCaptions = _ref.getCaptions;
  var appliedAddons = currentVersion.appliedAddons,
      submittedAt = currentVersion.submittedAt;
  var parsedAddons = (0, _lodash.default)(appliedAddons, ['__typename']);
  var captions = getCaptions(parsedAddons);
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "applied-addons"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "applied-addons__header"
    }, /*#__PURE__*/_react.default.createElement("h3", null, "APPLIED")), /*#__PURE__*/_react.default.createElement("div", {
      className: "applied-addons__list"
    }, Object.keys(parsedAddons).map(function (key) {
      var addonData = getFormattedAddon(key, parsedAddons);

      if (!addonData || !addonData.value) {
        return null;
      }

      return (/*#__PURE__*/_react.default.createElement(_Addon.default, {
          key: key,
          icon: addonData.icon,
          label: addonData.reviewLabel || addonData.label,
          submittedAt: submittedAt,
          status: addonData.status
        })
      );
    }), captions.map(function (_ref2) {
      var captionValue = _ref2.captionValue,
          type = _ref2.type,
          language = _ref2.language,
          status = _ref2.status;
      return (/*#__PURE__*/_react.default.createElement(_Addon.default, {
          key: "".concat(type, "-").concat(language),
          icon: captionValue.prefix,
          label: "".concat(captionValue.label, "(").concat(type, ")"),
          submittedAt: submittedAt,
          status: status
        })
      );
    })))
  );
}

var _default = (0, _react.memo)(Applied);

exports.default = _default;